<!-- DateInput.vue -->
<template>
  <div class="date-input">
    <input
      class="dt"
      type="date"
      :id="name"
      :name="name"
      :value="dateValue"
      autocomplete="off"
      required
      @input="onInput"
      @change="onInput"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  name: { type: String, default: 'date' },
  // ISO date only: "YYYY-MM-DD" (or '' / null)
  modelValue: { type: String, default: '' }
})

const emit = defineEmits(['update:modelValue'])

const dateValue = computed(() => {
  if (!props.modelValue) return ''
  const m = String(props.modelValue).match(/^(\d{4}-\d{2}-\d{2})/)
  return m ? m[1] : ''
})

const onInput = (e) => {
  const v = e.target.value // "YYYY-MM-DD"
  emit('update:modelValue', v || '')
}
</script>

<style scoped>
.date-input {
  position: relative;
}

/* Match your current look */
form input.dt {
  margin-bottom: 0px;
  padding-bottom: 0px;

  width: 480px;
  height: 44px;
  padding: 10px 12px;
  border: 1px solid #3b82f6;
  border-radius: 2px;
  font-size: 16px;
  box-sizing: border-box;
}

form input.dt:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
}
</style>
